/**
 * @voltxampere/ui — LM393 dual comparator variant (Sprint 39-4)
 *
 * Open-collector output threshold detector. The Sprint 7 single-pole
 * macro stamp models the comparator as an op-amp with V_OL ≈ 0.4 V
 * (low saturationVoltage), which captures the externally observable
 * behaviour for threshold detection / square-wave generation
 * circuits. The open-collector pull-up policy lands in a future
 * Inspector card (Sprint 41+).
 *
 * Reference: TI SNOSBT8H. Engine zero-diff invariant honored —
 * canonical "opamp" engine type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const opampLm393 = {
    id: "lm393",
    nameTr: "LM393 (Karşılaştırıcı, DIP-8)",
    nameEn: "LM393 (Comparator, DIP-8)",
    shortcut: "O",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "LM393",
    schemaType: "opamp",
    defaultParams: {
        openLoopGain: 2e5,
        saturationVoltage: 0.4,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=opamp-lm393.js.map